module.exports = __webpack_public_path__ + "img/TSM.62dfa87b.png";